import React from "react";
import "./SkeletonLoader.scss";

/**
 * Компонент skeleton loader с эффектом пробегающего косого света
 */
export const SkeletonLoader = ({ width = "100%", height = "20px", className = "" }) => {
  return (
    <div 
      className={`skeleton-loader ${className}`}
      style={{ width, height }}
    />
  );
};
